module.exports = __webpack_public_path__ + "static/img/4.01a82be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/eng/4.png
// module id = DjGE
// module chunks = 0